import { LightState } from '../types/protocol';
import { ColorCode, TrafficLightState } from '../types/intersection';

/**
 * Maps Protocol B color codes to individual light states (red, amber, green)
 */
export function colorCodeToLightStates(code: ColorCode): TrafficLightState {
  switch (code) {
    case ColorCode.D: // Apagado
    case ColorCode.N: // Negro
      return { red: LightState.OFF, amber: LightState.OFF, green: LightState.OFF };

    case ColorCode.V: // Verde fijo
    case ColorCode.P: // Verde peatonal
      return { red: LightState.OFF, amber: LightState.OFF, green: LightState.ON };

    case ColorCode.A: // Ámbar fijo
      return { red: LightState.OFF, amber: LightState.ON, green: LightState.OFF };

    case ColorCode.R: // Rojo fijo
    case ColorCode.H: // Rojo peatonal
      return { red: LightState.ON, amber: LightState.OFF, green: LightState.OFF };

    case ColorCode.S: // Verde parpadeante
    case ColorCode.I: // Verde peatonal parpadeante
      return { red: LightState.OFF, amber: LightState.OFF, green: LightState.FLASHING };

    case ColorCode.C: // Ámbar parpadeante
      return { red: LightState.OFF, amber: LightState.FLASHING, green: LightState.OFF };

    case ColorCode.F: // Rojo parpadeante
      return { red: LightState.FLASHING, amber: LightState.OFF, green: LightState.OFF };

    case ColorCode.B: // Rojo + ámbar (preparación)
      return { red: LightState.ON, amber: LightState.ON, green: LightState.OFF };

    case ColorCode.J: // Rojo + verde (error)
      return { red: LightState.ON, amber: LightState.OFF, green: LightState.ON };

    case ColorCode.G: // Verde rápido parpadeante
      return { red: LightState.OFF, amber: LightState.OFF, green: LightState.FLASHING_FAST };

    case ColorCode.E: // Ámbar rápido parpadeante
      return { red: LightState.OFF, amber: LightState.FLASHING_FAST, green: LightState.OFF };

    case ColorCode.K: // Alternante rojo-verde → ambos parpadeando
      return { red: LightState.FLASHING, amber: LightState.OFF, green: LightState.FLASHING };

    case ColorCode.Z: // Alternante rojo-ámbar → ambos parpadeando
      return { red: LightState.FLASHING, amber: LightState.FLASHING, green: LightState.OFF };

    default:
      return { red: LightState.OFF, amber: LightState.OFF, green: LightState.OFF };
  }
}
